import {XauditModel} from '../xaudit.model';

export class DataDoctorArPaymentProcessorModel extends XauditModel{
  LocPaymentProcessorId: string;
  DoctorARLocId: string;
  PaymentProcessorId: string;

  // added fields
  PaymentProcessorName: string;
  PaymentAmountTotal: number;
  ChargeSuccess: boolean = false;
  ARAccountName: string;
  PaymentID: string;
}
